import { useState } from "react";
import { ImagePlus, Loader2, X, Check } from "lucide-react";
import { toast } from "sonner";

const MAX_SIDE = 1800;

const resize = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("decode")); };
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      const out = canvas.toDataURL("image/jpeg", 0.85);
      if (out.length < 100) reject(new Error("canvas"));
      else resolve(out);
    };
    img.src = url;
  });

export const PRINT_SLOTS = [
  ["sobre", "Sobre", "Ajustes > Geral > Sobre"],
  ["bateria", "Bateria", "Ajustes > Bateria > Saúde da Bateria"],
  ["pecas", "Histórico de Peças e Serviço", "Ajustes > Geral > Sobre > Histórico de Peças e Serviço"],
  ["foto", "Foto do aparelho (opcional)", "Frente e verso, se quiser"],
];

// Um espaço para cada print pedido pela loja; a imagem é reduzida no próprio celular antes de enviar.
const Slot = ({ id, title, path, value, onChange, sfx }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onChange(await resize(file));
    } catch {
      toast.error("Não consegui abrir essa imagem. Tente um print em JPG ou PNG.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid={`trade-print-${id}${sfx}`} className={`flex items-center gap-3 rounded-2xl border p-3 transition-colors ${value ? "border-emerald-400/50 bg-emerald-400/[0.06]" : "border-white/10 bg-white/[0.03]"}`}>
      <label className="relative flex h-16 w-12 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-xl border border-dashed border-white/25 bg-black/40">
        {busy ? <Loader2 className="h-4 w-4 animate-spin text-zinc-300" /> : value ? <img src={value} alt={title} className="h-full w-full object-cover" /> : <ImagePlus className="h-5 w-5 text-zinc-300" />}
        <input data-testid={`trade-print-input-${id}${sfx}`} type="file" accept="image/*" onChange={pick} className="sr-only" />
      </label>
      <div className="min-w-0 flex-1">
        <p className="flex items-center gap-1.5 text-sm font-semibold text-white">{value && <Check className="h-4 w-4 text-emerald-300" />}{title}</p>
        <p className="mt-0.5 text-xs text-zinc-400">{path}</p>
      </div>
      {value && (
        <button type="button" data-testid={`trade-print-remove-${id}${sfx}`} onClick={() => onChange("")} aria-label="Remover" className="rounded-full p-2 text-zinc-300 hover:bg-white/10"><X className="h-4 w-4" /></button>
      )}
    </div>
  );
};

export const TradePrints = ({ prints, setPrints, sfx = "" }) => (
  <div className="space-y-2.5">
    {PRINT_SLOTS.map(([id, title, path]) => (
      <Slot key={id} id={id} sfx={sfx} title={title} path={path} value={prints[id] || ""} onChange={(v) => setPrints((p) => ({ ...p, [id]: v }))} />
    ))}
  </div>
);
